import styled from 'styled-components'
import theme from '@app/ui/theme'
import { LIST_SPINNER_SIZE } from '@app/components/atoms/ListState'

export const TableContainer = styled.div`
  width: 100%;
  margin-top: 20px;
  overflow-x: auto;
`

export const CoursesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`

export const Center = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: ${LIST_SPINNER_SIZE}px;
  padding: 24px 0;
`

export const Empty = styled.span`
  display: flex;
  align-items: center;
  min-height: ${LIST_SPINNER_SIZE}px;
  padding: 24px 0;
  color: rgba(0, 0, 0, 0.75);
`

export const CourseCard = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  gap: 18px;

  padding: 16px 14px;
  border-radius: ${theme.borderRadius}px;

  background: #fff;
  border-top: 1px solid rgba(0, 0, 0, 0.1);

  &:last-child {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }

  color: rgba(0, 0, 0, 0.85);

  @media (max-width: 560px) {
    flex-direction: column;
  }
`

export const CourseMain = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 14px;
`

export const CourseHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const NameRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
`

export const CourseName = styled.div`
  font-size: 18px;
  font-weight: 800;
  letter-spacing: 0.2px;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const TeeRow = styled.div`
  margin-left: auto;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
`

export const TeePill = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;

  font-weight: 700;
  line-height: 1;
  color: rgba(0, 0, 0, 0.8);
`

export const TeeName = styled.span`
  white-space: nowrap;
`

export const InfoRow = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 18px;

  @media (max-width: 980px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`

export const InfoItem = styled.div`
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
`

export const InfoLabel = styled.div`
  font-size: 12px;
  letter-spacing: 0.6px;
  color: rgba(0, 0, 0, 0.55);
  font-weight: 700;
`

export const InfoValue = styled.div`
  min-width: 0;
  height: 100%;
  display: flex;
  align-items: center;
  gap: 10px;

  font-size: 16px;
  font-weight: 800;
  color: rgba(0, 0, 0, 0.8);

  > * {
    min-width: 0;
  }
`

export const Dash = styled.span`
  color: rgba(0, 0, 0, 0.55);
  font-weight: 800;
`

export const HoleBadge = styled.div`
  text-align: left;
  margin: 0px;
  border: 1px solid #ccc;
  width: 32px;
  height: 32px;
  border-radius: ${theme.borderRadius}px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${theme.colors.primary};
  font-weight: 600;
  font-size: 15px;
`

export const Actions = styled.div`
  width: 280px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 12px;

  @media (max-width: 680px) {
    width: 220px;
  }

  @media (max-width: 560px) {
    width: 100%;
  }
`
